import { render, staticRenderFns } from "./ReferenceMatrix.vue?vue&type=template&id=d607c626&scoped=true&lang=pug"
import script from "./ReferenceMatrix.vue?vue&type=script&lang=js"
export * from "./ReferenceMatrix.vue?vue&type=script&lang=js"
import style0 from "./ReferenceMatrix.vue?vue&type=style&index=0&id=d607c626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d607c626",
  null
  
)

export default component.exports